import React, { useRef, useState, useEffect } from "react";
import TrialDemoCRM from "../Components/TrialDemoCRM";
import {
    FaHtml5,
    FaCss3Alt,
    FaReact,
    FaNodeJs,
    FaBootstrap,
    FaPhp,
    FaLaravel,
    FaDatabase,
    FaWordpress,
    FaCode, // Placeholder for Visual Basic
} from "react-icons/fa";
import { SiMysql } from "react-icons/si"; // MySQL from Simple Icons
import { BsGearFill } from "react-icons/bs"; // Placeholder for CRM
import { Helmet } from 'react-helmet';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Style.css";
import { NavLink } from 'react-router-dom';
import banner from './assets/banner-left.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom"
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaMapMarkerAlt, FaPhoneAlt, FaClock } from "react-icons/fa";

import aboutImage from './assets/about-image.png'; // Add the About section image
import aboutimageposition from './assets/about-image-position.png'; // Add the About section image
import counterone from './assets/counter-one.png'; // Add the About section image
import countertwo from './assets/counter-two.png'; // Add the About section image

import serviceImgOne from './assets/service-img-1.png'; // Add the About section image
import serviceImgTwo from './assets/service-img-2.png'; // Add the About section image
import serviceImgThree from './assets/service-img-3.png'; // Add the About section image
import serviceImgFour from './assets/service-img-4.png'; // Add the About section image

import serviceIconOne from './assets/serviceIconOne.png'; // Add the About section image
import serviceIconTwo from './assets/serviceIconTwo.png'; // Add the About section image
import serviceIconThree from './assets/serviceIconThree.png'; // Add the About section image
import serviceIconFour from './assets/serviceIconFour.png'; // Add the About section image

import followIconOne from './assets/followIconOne.png'; // Add the About section image
import followIconTwo from './assets/followIconTwo.png'; // Add the About section image
import followIconThree from './assets/followIconThree.png'; // Add the About section image
import followIconFour from './assets/followIconFour.png'; // Add the About section image

import image1 from "./assets/home-slider-1.png";
import image2 from "./assets/home-slider-3.png";
import image3 from "./assets/home-slider-2.png";
import image4 from "./assets/home-slider-4.png";
import image5 from "./assets/home-slider-5.png";
import image6 from "./assets/home-slider-6.png";

import teamOne from "./assets/charlotte-amitina.png";
import teamTwo from "./assets/william-edward.png";
import teamThree from "./assets/hannah-chloe.png";
import teamFour from "./assets/maiselan-willam.png";
//import user from "./assets/user.jpg";

//import Button from 'react-bootstrap/Button';
//import Form from 'react-bootstrap/Form';

import apppointImg from './assets/apppoint-img.jpg'; // Add the About section image

import testiAuthorOne from './assets/testi-author-1.png'; // Add the About section image
import testiAuthorTwo from './assets/testi-author-2.png'; // Add the About section image
import testiAuthorThree from './assets/testi-author-3.png'; // Add the About section image

import news1 from './assets/news-1.jpg'; // Replace with actual image path
import news2 from './assets/news-2.jpg'; // Replace with actual image path
import news3 from './assets/news-3.jpg'; // Replace with actual image path


const Home = () => {

    /* start contact form script */
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        topic: "",
        message: "",
    });

    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://d-api.dotlocalhost.com/contact.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.success) {
                setStatus("Message sent successfully!");
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    topic: "",
                    message: "",
                });
            } else {
                setStatus("Failed to send message. Please try again.");
            }
        } catch (error) {
            setStatus("An error occurred. Please try again later.");
        }
    };
    /* Ends contact form script */

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
        ],
    };

    // starts of counter
    const [counter1, setCounter1] = useState(0);
    const [counter2, setCounter2] = useState(60);

    useEffect(() => {
        // Counter 1: Automatically increments from 0 to 300
        const interval1 = setInterval(() => {
            setCounter1((prev) => {
                if (prev < 16) {
                    return prev + 1;
                }
                clearInterval(interval1); // Stop incrementing once it reaches 300
                return prev;
            });
        }, 50); // Adjust the speed of the counter

        // Counter 2: Automatically increments from 60 to 1200
        const interval2 = setInterval(() => {
            setCounter2((prev) => {
                if (prev < 2200) {
                    return prev + 10;
                }
                clearInterval(interval2); // Stop incrementing once it reaches 1200
                return prev;
            });
        }, 50); // Adjust the speed of the counter

        return () => {
            clearInterval(interval1);
            clearInterval(interval2);
        };
    }, []);
    // ends of counter

    // start recent photo gallery
    const slides = [image1, image2, image3, image4, image5, image6];

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? slides.length - 1 : prevIndex - 1
        );
    };
    // ends recent photo gallery

    // start Marqee section
    const marqueeRef = useRef(null);
    const speed = 20; // Speed in seconds

    useEffect(() => {
        const marquee = marqueeRef.current;

        if (marquee) {
            marquee.style.animationDuration = `${speed}s`;

            // Pause marquee on mouse hover
            const handleMouseOver = () => {
                marquee.style.animationPlayState = "paused";
            };

            const handleMouseOut = () => {
                marquee.style.animationPlayState = "running";
            };

            marquee.addEventListener("mouseover", handleMouseOver);
            marquee.addEventListener("mouseout", handleMouseOut);

            return () => {
                marquee.removeEventListener("mouseover", handleMouseOver);
                marquee.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, [speed]);
    // ends Marqee section

    // statr price plan section
    const [billingCycle, setBillingCycle] = useState('developing');

    const plans = {
        developing: [
            { name: 'Static Website', price: '$500', description: 'Perfect for individuals.', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;3 Page Website</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;4 Creative Designers</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Stock Images</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;1 JQuery Slider Banner</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Contact/Query Form</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;48 To 72 Hours TAT</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Complete Deployment</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% Satisfaction Guarantee</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% Unique Design Guarantee</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% Digitally Designed Artwork</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Unlimited Revisions</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Money Back Guarantee</>] },
            { name: 'Ecommerce Website', price: '$950', description: 'Ideal for small teams.', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;10 Unique Pages Website</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;CMS / Admin Panel Support</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;12 Stock Images</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;5 Banner Designs</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;1 JQuery Slider Banner</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Social Media Integration</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Complete Deployment</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;FREE Google Friendly Sitemap</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% Unique Design Guarantee</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;48 To 72 Hours TAT</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Unlimited Revisions</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Money Back Guarantee</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Money Back Guarantee</>] },
            { name: 'Full Stack Web Development', price: '$1500', description: 'Best for large organizations.', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Custom Made, Interactive, Dynamic & High End Design</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Custom WP (Or) Custom PHP Development</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;1 JQuery Slider Banner</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Up To 10 Custom Made Banner Designs</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;10 Stock Images</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Unlimited Revisions</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Special Hover Effects</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Content Management System (CMS)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Online Appointment/Scheduling/Online Ordering</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Integration (Optional)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Online Payment Integration (Optional)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Multi Lingual (Optional)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Custom Dynamic Forms (Optional)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Signup Area (For Newsletters, Offers Etc.)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Search Bar</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Live Feeds Of Social Networks Integration (Optional)</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Mobile Responsive</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;15 Seconds 2D Explainer Video</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Voice - Over & Sound Effects</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Professional Script Writing Storyboard</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;SEO Meta Tags</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;FREE 5 Years Domain Name</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Free Google Friendly Sitemap</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Search Engine Submission</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Complete W3C Certified HTML</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Industry Specified Team Of Expert Designers And Developers</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Complete Deployment</>] },
        ],
        social: [
            { name: 'Personal', price: '$300', description: 'For individuals just starting out', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;1 Business</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;1 Posting time per day</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Generate 300 posts per month</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;4 Connected socials</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Schedule out 3 months of content</>] },
            { name: 'Professional', price: '$500', description: 'For individuals and teams looking to get the most out of Marky', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;2 Businesses</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Multiple posting times per day</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Generate 600 posts per a month</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Unlimited connected socials</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Schedule indefinitely into the future</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Team access</>] },
            { name: 'Agency', price: '$800', description: 'For individuals and teams who want to use Marky for their clients', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;10 Businesses</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Multiple posting times per day</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Generate 3,000 posts per a month</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Unlimited connected socials</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Schedule indefinitely into the future</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Team access</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;White labeled client portal</>] },
        ],
        graphic: [
            { name: 'Basic', price: '$50', description: 'Perfect for individuals.', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Creative concepts x 1</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Number of revisions x 2</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% client satisfaction</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Delivery in 24 hours</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;All formats will be provided</>] },
            { name: 'Standard', price: '$95', description: 'Ideal for small teams.', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Creative concepts x 3</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Number of revisions x 2</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Number of designers x 2</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;All sizes social media handles</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Delivery in 24-36 hours</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;All files format</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% ownership rights & client satisfaction</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Business card design</>] },
            { name: 'Platinum', price: '$145', description: 'Best for large organizations.', Features: [<><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;3d / mascot / illustrative logo design</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Number of concepts x 1</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Number of revisions x 3</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Ai, Psd, Jpeg, PNG, pdf files format included</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Different sizes for social media handles</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Number of dedicated designers x 2</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Business Card design Free</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;Letterhead Design free</>, <><span style={{ color: '#3f5af3', fontSize: '20px' }}>✔</span>&nbsp;&nbsp;&nbsp;100% satisfaction and ownership rights</>] },
        ],
    };


    // ends price plan section

    // starts Clients Feedback section
    const teamMembers = [
        {
            name: '— Sarah Mitchell, Founder of GreenTech Solutions',
            role: 'Exceptional Web Development Services',
            description: '"Working with dotlocalhost has been an absolute pleasure! Their team took the time to understand our business needs and created a stunning website that exceeded our expectations. The design is sleek, user-friendly, and perfectly represents our brand. They delivered on time and kept us updated throughout the process. Highly recommended!"',
            image: testiAuthorTwo, // Replace with actual images
        },
        {
            name: '— James Carter, CEO of Urban Eats',
            role: 'Outstanding Social Media Marketing',
            description: '"Dotlocalhost transformed our social media presence! Their team developed a creative and effective marketing strategy that boosted our engagement and brought in new customers. The results have been phenomenal, and their professionalism and expertise are unmatched. We couldn’t be happier with their work!"',
            image: testiAuthorOne, // Replace with actual images
        },
        {
            name: 'Roberts William, Marketing Manager at Luxe Interiors',
            role: 'Creative Graphic Designing and Performance Marketing',
            description: '"The graphic design team at dotlocalhost is incredibly talented! They designed eye-catching visuals for our campaigns that truly captured our brand’s essence. Combined with their performance marketing expertise, our sales skyrocketed within weeks. They’re a one-stop solution for all digital needs!"',
            image: testiAuthorThree, // Replace with actual images
        },
    ];
    // Ends Clients Feedback section

    // Start News section
    const blogPosts = [
        {
            date: 'April 1, 2024',
            author: 'Runok',
            title: 'How Agecis Puts Your Audience First In Every Website Project',
            image: news1,
        },
        {
            date: 'April 5, 2024',
            author: 'Runok',
            title: 'Ensures Your Website Rises To The Top Of Search Rankings',
            image: news2,
        },
        {
            date: 'April 11, 2024',
            author: 'Runok',
            title: 'Strategies For Effective Web Design By Our Agency',
            image: news3,
        },
    ];
    // Ends News section

    return (
        <>
            {/* Meta title and descriptions */}
            <Helmet>
                <title>DotLocalHost - Your Premier Web Development & Hosting Solutions</title>
                <meta name="description" content="Discover cutting-edge web development, reliable hosting, and expert digital solutions at DotLocalHost. Build your online presence with us today!" />
                <meta name="keywords" content="web development, hosting, React.js, DotLocalHost" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="DotLocalHost - Home" />
                <meta property="og:description" content="Your trusted partner for web development and hosting." />
                <meta property="og:url" content="https://dotlocalhost.com/" />
                <meta property="og:image" content="https://dotlocalhost.com/images/home-og.jpg" />
            </Helmet>

            {/* Banner Section */}
            <div className="container-fluid banner-container">
                <div className="row align-items-center justify-content-between banner-content">
                    <div className="col-md-8 col-lg-6 text-column text-center text-md-start">
                        <h1>
                            TURNED <span>Into</span> Reality
                        </h1>

                        <h3>
                            Beyond Marketing & Development — Your Digital Growth Partner for US Businesses
                        </h3>

                        <p>
                            <b>Top-Tier Digital Marketing & Web Development Services for US Businesses.</b>
                        </p>

                        <p>
                            We turn ideas into reality with creative problem-solving, strategic design, and performance-driven solutions that deliver measurable results.
                        </p>

                        <button className="btn cta-button d-grid" style={{ marginTop: '20px' }}>
                            <Link to="/services" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                Get Started Now
                            </Link>
                        </button>
                    </div>
                    <div className="col-md-4 col-lg-4 image-column">
                        <img src={banner} alt="banner" className="img-fluid banner-image" />
                    </div>
                </div>
            </div>

            {/* Icon Slider */}
            <div className="icon-slider-container py-5" style={{ marginTop: '100px' }}>
                <div className="container">
                    <div className="slider-wrapper">
                        <Slider {...settings}>
                            <div className="icon-slide text-center">
                                <FaHtml5 size={100} color="#e34f26" />
                                <p>HTML5</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaCss3Alt size={100} color="#2965f1" />
                                <p>CSS3</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaReact size={100} color="#61DBFB" />
                                <p>React</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaNodeJs size={100} color="#68A063" />
                                <p>Node.js</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaBootstrap size={100} color="#563d7c" />
                                <p>Bootstrap</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaPhp size={100} color="#777BB4" />
                                <p>PHP</p>
                            </div>
                            <div className="icon-slide text-center">
                                <BsGearFill size={100} color="#FF5733" />
                                <p>CRM</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaLaravel size={100} color="#FF2D20" />
                                <p>Laravel</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaDatabase size={100} color="#4DB33D" />
                                <p>Database</p>
                            </div>
                            <div className="icon-slide text-center">
                                <SiMysql size={100} color="#00758F" />
                                <p>MySQL</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaWordpress size={100} color="#21759B" />
                                <p>WordPress</p>
                            </div>
                            <div className="icon-slide text-center">
                                <FaCode size={100} color="#5C2D91" />
                                <p>Visual Basic</p>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className="about-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left Image Column */}
                        <div className="col-md-6">
                            <img src={aboutImage} alt="About Us" className="img-fluid about-image" />
                            <img src={aboutimageposition} alt="About Us" className="img-fluid about-possison" />
                        </div>
                        {/* Right Text Column */}
                        <div className="col-md-6 text-column">
                            <p className="section-tagline">WHO WE ARE</p>
                            <h2>Over 8 Years of Proven Success in Digital Marketing & Web Solutions</h2>
                            <p>
                                <b>– Helping brands across the US grow with cutting-edge strategies.</b>
                            </p>
                            <p>
                                Custom IT Solutions Designed for Your Business Success – Tailored IT design, management, and support to help your brand thrive in the competitive US market.
                            </p>

                            <div className="container py-5">
                                <div className="row justify-content-center">
                                    {/* Counter 1 */}
                                    <div className="col-12 col-md-5 text-center border p-4 m-2">
                                        <img src={counterone} alt="Counter 1" className="img-fluid mb-3 section-icon" />
                                        <h3 className="display-4">{counter1}</h3>
                                        <p>Years on the market</p>
                                    </div>

                                    {/* Counter 2 */}
                                    <div className="col-12 col-md-5 text-center border p-4 m-2">
                                        <img src={countertwo} alt="Counter 2" className="img-fluid mb-3 section-icon" />
                                        <h3 className="display-4">{counter2}</h3>
                                        <p>Projects delivered so far</p>
                                    </div>
                                </div>
                            </div>

                            <button className="btn"><Link to="/contact" style={{ textDecoration: 'none', color: '#ffffff' }}>Get Started Now</Link></button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Service Section */}
            <div className="about-section py-5">
                <div className="container">
                    <div className="row">
                        {/* left Text Column */}
                        <div className="col-md-5 mt-5 text-column serviceLeftColumn">
                            <p className="section-tagline">SERVICE WE OFFER</p>
                            <h2>Innovative Web Solutions That Elevate Your Brand</h2>

                            <button className="btn cta-button"><Link to="/services" style={{ textDecoration: 'none', color: '#ffffff' }}>More Services</Link></button>
                        </div>
                        {/* right Image Column */}
                        <div className="col-md-7">
                            <div className="container py-5 service-column serviceRightBox">
                                <div className="row justify-content-center">

                                    <div className="col-12 col-md-5 text-center servimageone">
                                        <NavLink to="/web-developing" className="servicePage-link">
                                            <img src={serviceIconOne} alt="Counter 1" className="img-fluid mb-3 section-icon" />
                                            <h3 className="display-4 mt-3">Web Development</h3>
                                            <img src={serviceImgOne} alt="Counter 1" className="img-fluid mb-3 service-image" />
                                        </NavLink>
                                    </div>

                                    <div className="col-12 col-md-5 text-center servimagetwo">
                                        <NavLink to="/web-application" className="servicePage-link">
                                            <img src={serviceIconTwo} alt="Counter 1" className="img-fluid mb-3 section-icon" />
                                            <h3 className="display-4 mt-3">Web Application</h3>
                                            <img src={serviceImgTwo} alt="Counter 1" className="img-fluid mb-3 service-image" />
                                        </NavLink>
                                    </div>
                                </div>
                                <div className="row justify-content-center ">
                                    <div className="col-12 col-md-5 text-center servimagethree">
                                        <NavLink to="/social-media" className="servicePage-link">
                                            <img src={serviceIconThree} alt="Counter 1" className="img-fluid mb-3 section-icon" />
                                            <h3 className="display-4 mt-3">Social Media Management</h3>
                                            <img src={serviceImgThree} alt="Counter 1" className="img-fluid mb-3 service-image" />
                                        </NavLink>
                                    </div>

                                    <div className="col-12 col-md-5 text-center servimagefour">
                                        <NavLink to="/graphic-design" className="servicePage-link">
                                            <img src={serviceIconFour} alt="Counter 1" className="img-fluid mb-3 section-icon" />
                                            <h3 className="display-4 mt-3">Graphic Design Services</h3>
                                            <img src={serviceImgFour} alt="Counter 1" className="img-fluid mb-3 service-image" />
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section py-5">
                <TrialDemoCRM />
            </div>

            {/* work process Section */}
            <div className="work-section py-5">
                <div className="container">
                    <p className="section-work-tagline ">OUR WORK PROCESS</p>
                    <h2>Follow 4 Easy Work Steps</h2>

                    <div className="row mt-5">
                        <div className="col-md-3 work-card">
                            <div className="work-icon-cover">
                                <img src={followIconOne} alt="Counter 1" className="img-fluid mb-3 round-work-icon" />
                            </div>
                            <h4>Process-1</h4>
                            <h3>Project Research</h3>
                            <h5>Objective:</h5>
                            <p><b>We Start with Your Business Goals</b></p>
                            <p>– Our in-depth research ensures we craft strategies that align perfectly with your brand’s success.</p>
                        </div>
                        <div className="col-md-3 work-card">
                            <div className="work-icon-cover">
                                <img src={followIconTwo} alt="Counter 1" className="img-fluid mb-3 round-work-icon" />
                            </div>
                            <h4>Process-2</h4>
                            <h3>Start Working</h3>
                            <h5>Objective:</h5>
                            <p><b>Precision Execution by Our Expert Team</b></p>
                            <p>– Once the strategy is set, our specialists bring your project to life with efficiency and excellence.</p>
                        </div>
                        <div className="col-md-3 work-card">
                            <div className="work-icon-cover">
                                <img src={followIconThree} alt="Counter 1" className="img-fluid mb-3 round-work-icon" />
                            </div>
                            <h4>Process-3</h4>
                            <h3>Quality Products</h3>
                            <h5>Objective:</h5>
                            <p><b>Delivering High-Impact Digital Solutions</b></p>
                            <p>– Our results-driven approach ensures your expectations are not just met but exceeded.</p>
                        </div>
                        <div className="col-md-3 work-card">
                            <div className="work-icon-cover">
                                <img src={followIconFour} alt="Counter 1" className="img-fluid mb-3 round-work-icon" />
                            </div>
                            <h4>Process-4</h4>
                            <h3>Quality Finished</h3>
                            <h5>Objective:</h5>
                            <p><b>Perfection in Every Project – Leaving a Lasting Impression</b></p>
                            <p>– We create powerful digital experiences that captivate and engage your audience.</p>
                        </div>
                    </div>

                </div>
            </div>

            {/* Marqee Section */}
            {/*            
            <div className="marqee-section py-5">
                <div className="">
                    <div className="marquee-container">
                        <div className="marquee" ref={marqueeRef}>
                            <span>Latest Projects</span>
                            <span>Web Development</span>
                            <span>Latest Projects</span>
                            <span>Web Development</span>
                            <span>Latest Projects</span>
                            <span>Web Development</span>
                        </div>
                    </div>
                </div>
            </div>
*/}

            {/* recent photo gallery Section */}
            {/*             
            <div className="recent-photo-section py-5">
                <div className="">
                    <div className="project-gallery">
                        <p className="section-tagline">RECENT WORKS GALLERY</p>
                        <h2 className="mb-5">OUR RECENT PROJECT GALLERY</h2>

                        <div className="slider-container">
                            <button className="arrow left" onClick={handlePrev}>
                                &#10094;
                            </button>
                            <div className="slider" style={{ transform: `translateX(-${currentIndex * 40}%)` }}>
                                {slides.map((slide, index) => (
                                    <div className="slide" key={index}>
                                        <img src={slide} alt={`Slide ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                            <button className="arrow right" onClick={handleNext}>
                                &#10095;
                            </button>
                        </div>

                    </div>
                </div>
            </div>
*/}

            {/* Simple Card Section */}
            <div className="simple-card-section py-5">
                <div className="container">

                    <div className="row mt-5 simpleCard">
                        <div className="col-md-3 simple-card-one">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Years of</p>
                                    <p>Experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 simple-card-two">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Sillded</p>
                                    <p>Perforamce</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 simple-card-three">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Visited</p>
                                    <p>Conference</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 simple-card-four">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Years of</p>
                                    <p>Experience</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Team Members Section */}
            <div className="team-mambers-section py-5">
                <div className="container">
                    <p className="section-tagline">TEAM MEMBERS</p>
                    <h2 className="mb-5">EXPERIENCE TEAM MEMBER</h2>

                    <div className="row mt-5 team-card">

                        <div className="col-md-3 team-card-one">
                            <div className="team-card-wrapper">
                                <img src={teamOne} alt="Charlotte Amitina" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>Charlotte Amitina</h3>
                            <p>Ui/Ux Designer</p>
                        </div>

                        <div className="col-md-3 team-card-two">
                            <div className="team-card-wrapper">
                                <img src={teamTwo} alt="William Edward" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>William Edward</h3>
                            <p>Project Manager</p>
                        </div>

                        <div className="col-md-3 team-card-three">
                            <div className="team-card-wrapper">
                                <img src={teamThree} alt="Hannah Chloe" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>Hannah Chloe</h3>
                            <p>Product Designer</p>
                        </div>

                        <div className="col-md-3 team-card-four">
                            <div className="team-card-wrapper">
                                <img src={teamFour} alt="Maiselan Willam" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>Maiselan Willam</h3>
                            <p>Web Developer</p>
                        </div>

                    </div>

                </div>
            </div>

            {/* Pricing Plan Section */}
            <div className="price-section py-5">
                <div className="container">
                    <p className="section-tagline">OUR PRICING PLANS</p>
                    <h2 className="mb-5">OUR FLEXIBLE PRICING</h2>

                    <div className="price-table">
                        <div className="tabs">
                            <button
                                className={billingCycle === 'developing' ? 'active' : ''}
                                onClick={() => setBillingCycle('developing')}
                            >
                                Web Developing <span>30%</span>
                            </button>
                            <button
                                className={billingCycle === 'social' ? 'active' : ''}
                                onClick={() => setBillingCycle('social')}
                            >
                                Social Media Management
                            </button>
                            <button
                                className={billingCycle === 'graphic' ? 'active' : ''}
                                onClick={() => setBillingCycle('graphic')}
                            >
                                Graphic Design Services
                            </button>
                        </div>

                        <div className="plans">
                            {plans[billingCycle].map((plan, index) => (
                                <div className="plan" key={index}>
                                    <p>{plan.name}</p>
                                    <h3 className="price">{plan.price}</h3>
                                    <p className="description">{plan.description}</p>
                                    <div className="buttons price-button">
                                        <button className="get-in-touch"><Link to="/contact" style={{ textDecoration: 'none', color: '#ffffff' }}>Get In Touch</Link></button>
                                    </div>
                                    <ul className="features-list">
                                        {plan.Features.map((feature, idx) => (
                                            <li key={idx}>{feature}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>

            {/* New Contact Section */}
            <div className="company-section py-5">
                <div className="container">
                    <div className="contact-us-container">
                        {/* Left Section - Contact Info */}
                        <div className="contact-info">
                            <img src={apppointImg} alt="About Us" className="img-fluid about-image" />
                        </div>

                        {/* Right Section - Contact Form */}
                        <div className="contact-form newForm">
                            <p className="section-tagline">Our Contact Us</p>
                            <h2>Have Any Contact! Say The People Trust Us</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name*"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                    <input
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name*"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-row">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email address*"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone number*"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-row">
                                    <select
                                        name="topic"
                                        value={formData.topic}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Query Topic</option>
                                        <option value="General Inquiry">General Inquiry</option>
                                        <option value="Support">Support</option>
                                        <option value="Collaboration">Collaboration</option>
                                    </select>
                                </div>
                                <div className="form-row">
                                    <textarea
                                        name="message"
                                        placeholder="Message*"
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                <button type="submit">Submit Message</button>
                                {status && <p className="form-status">{status}</p>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Section */}
            {/*            
            <div className="about-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        
                        <div className="col-md-6">
                            <img src={apppointImg} alt="About Us" className="img-fluid about-image" />
                        </div>
                        
                        <div className="col-md-6 text-column">
                            <p className="section-tagline">Our Contact Us</p>
                            <h2>Have Any Contact! Say The People Trust Us</h2>

                            <Form>
                                <div className="row">
                                    <div className="col-6 mt-3">
                                        <Form.Control type="text" placeholder="Enter First Name" />
                                    </div>
                                    <div className="col-6 mt-3">
                                        <Form.Control type="text" placeholder="Enter Last Name" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 mt-3">
                                        <Form.Control type="email" placeholder="Enter Yor Email" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 mt-3">
                                        <Form.Control type="text" placeholder="Message" />
                                    </div>
                                </div>

                                <button className="btn cta-button mt-3">Submit</button>
                            </Form>

                        </div>
                    </div>
                </div>
            </div>
*/}


            {/* Clients Feedback Section */}
            <div className="work-section py-5">
                <div className="container">
                    <p className="section-work-tagline ">TESTIMONIALS</p>
                    <h2>CLIENTS FEEDBACK</h2>

                    <div className="team-section">
                        {teamMembers.map((member, index) => (
                            <div className="team-member" key={index}>
                                <img src={member.image} alt={`${member.name}`} className="team-image" />
                                <p className="team-role">{member.role}</p>
                                <p className="team-description">{member.description}</p>
                                <h3 className="team-name">{member.name}</h3>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            {/* latest news Section */}
            {/*            
            <div className="work-section py-5">
                <div className="container">
                    <p className="section-work-tagline ">NEWS & LATEST UPDATES</p>
                    <h2>Our latest news & articles from the blog</h2>

                    <section className="blog-section">
                        <div className="blog-container">
                            {blogPosts.map((post, index) => (
                                <div className="blog-card" key={index}>
                                    <img src={post.image} alt={post.title} className="blog-image" />
                                    <div className="blog-content">
                                        <p className="blog-date">
                                            <span>{post.date}</span> <span>POST BY: {post.author}</span>
                                        </p>
                                        <h3 className="blog-title">{post.title}</h3>
                                        <button className="read-more-btn">
                                            Read More <span>↗</span>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                </div>
            </div>
*/}

        </>
    );
};

export default Home;
